(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ga-blog-shop-the-story"] && !Shopify.designMode) return;
  try {
    (function() {
  function meaningfulBlocks(parent, module) {
    var allowed = ['P', 'H2', 'H3', 'H4', 'UL', 'OL', 'BLOCKQUOTE', 'FIGURE', 'TABLE'];

    return Array.from(parent.children).filter(function(element) {
      if (element === module) return false;
      if (allowed.indexOf(element.tagName) === -1) return false;

      if (element.tagName === 'FIGURE' || element.tagName === 'TABLE') {
        return true;
      }

      return (element.textContent || '').trim().length >= 20;
    });
  }

  function findContentBlocks(article, module) {
    var direct = meaningfulBlocks(article, module);

    if (direct.length >= 6) {
      return { parent: article, blocks: direct };
    }

    var wrappers = Array.from(article.children).filter(function(element) {
      if (element === module) return false;
      return element.tagName === 'DIV' || element.tagName === 'SECTION';
    });

    var bestParent = article;
    var bestBlocks = direct;

    wrappers.forEach(function(wrapper) {
      var blocks = meaningfulBlocks(wrapper, module);

      if (blocks.length > bestBlocks.length) {
        bestParent = wrapper;
        bestBlocks = blocks;
      }
    });

    return { parent: bestParent, blocks: bestBlocks };
  }

  function mountModule(module) {
    if (!module || module.dataset.gaMounted === 'true') return;

    var article = module.closest('.article');
    if (!article) return;

    module.dataset.gaMounted = 'true';

    var result = findContentBlocks(article, module);
    var blocks = result.blocks;

    if (blocks.length >= 6) {
      var targetIndex = Math.round((blocks.length - 1) * 0.60);
      targetIndex = Math.max(1, Math.min(blocks.length - 2, targetIndex));

      while (
        targetIndex > 0 &&
        ['H2', 'H3', 'H4'].indexOf(blocks[targetIndex].tagName) !== -1
      ) {
        targetIndex -= 1;
      }

      blocks[targetIndex].insertAdjacentElement('afterend', module);
    }

    if (blocks.length >= 22 && !article.querySelector('[data-ga-blog-story-end]')) {
      var template = module.querySelector('[data-ga-blog-end-cta-template]');

      if (template && template.content && template.content.firstElementChild) {
        article.appendChild(template.content.firstElementChild.cloneNode(true));
      }
    }
  }

  function initialise(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-ga-blog-shop-story]').forEach(function(module) {
      mountModule(module);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initialise(document);
    });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initialise(event.target || document);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
